import API from './api';

// Servicio para los usuarios
const userService = {
  // Obtener todos los usuarios (solo admin)
  getUsers: async (filters = {}) => {
    const response = await API.get('/users', { params: filters });
    console.log('🔍 userService.getUsers response:', response.data);
    return response.data;
  },

  // Obtener un usuario por ID (solo admin)
  getUserById: async (id) => {
    const response = await API.get(`/users/${id}`);
    return response.data;
  },

  // Crear un nuevo usuario (solo admin)
  createUser: async (userData) => {
    const response = await API.post('/users/admin', userData);
    return response.data;
  },

  // Actualizar un usuario (solo admin)
  updateUser: async (id, userData) => {
    const response = await API.put(`/users/${id}`, userData);
    return response.data;
  },

  // Eliminar un usuario (solo admin) - DESACTIVA, no elimina
  deleteUser: async (id) => {
    const response = await API.delete(`/users/${id}`);
    return response.data;
  },

  // Eliminar PERMANENTEMENTE un usuario (solo admin)
  permanentDeleteUser: async (id) => {
    const response = await API.delete(`/users/${id}/permanent`);
    return response.data;
  },

  // Cambiar el rol de un usuario (solo admin)
  changeUserRole: async (id, role) => {
    const response = await API.put(`/users/${id}/role`, { role });
    return response.data;
  },

  // Activar/desactivar un usuario (solo admin)
  toggleUserStatus: async (id, status) => {
    const response = await API.put(`/users/${id}/status`, { status });
    return response.data;
  },

  // Silenciar/desilenciar un usuario (solo admin)
  toggleSilenciado: async (id) => {
    const response = await API.put(`/users/${id}/silenciar`);
    return response.data;
  },

  // Añadir saldo al monedero de un usuario (solo admin)
  addWalletBalance: async (id, amount) => {
    const response = await API.put(`/users/${id}/wallet`, { amount });
    return response.data;
  },

  // Obtener estadísticas de usuarios (solo admin)
  getUserStats: async () => {
    const response = await API.get('/users/stats');
    return response.data;
  },

  // Buscar usuarios por nombre o email (solo admin)
  searchUsers: async (query) => {
    const response = await API.get(`/users/search?q=${query}`);
    return response.data;
  },

  // Actualizar perfil extendido del usuario
  updateExtendedProfile: async (profileData) => {
    const response = await API.put('/users/extended-profile', profileData);
    return response.data;
  },

  // Obtener estado del perfil extendido
  getExtendedProfileStatus: async () => {
    const response = await API.get('/users/extended-profile/status');
    return response.data;
  },

  // Obtener perfil del usuario actual
  getProfile: async () => {
    const response = await API.get('/users/profile');
    return response.data;
  },

  // Métodos adaptados para useCRUD hook
  getAll: (filters = {}) => {
    return userService.getUsers(filters);
  },

  create: (data) => {
    return userService.createUser(data);
  },

  update: (id, data) => {
    return userService.updateUser(id, data);
  },

  delete: (id) => {
    return userService.deleteUser(id);
  },

  getById: (id) => {
    return userService.getUserById(id);
  }
};

export default userService;
